import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

const selectDevtoolsUserState = (state: AppStateType) => state?.users?.devtoolsUser;

export const selectIsAuthDataLoading = createSelector([selectDevtoolsUserState], state => state?.isLoading);

export const selectDevtoolsUserAuthToken = createSelector(
  [selectDevtoolsUserState],
  state => state?.data?.access_token,
);

export const selectAuthErrorMessage = createSelector([selectDevtoolsUserState], state => state.error?.message || '');

export const selectDevtoolsUserRefreshToken = createSelector(
  [selectDevtoolsUserState],
  state => state.data?.refresh_token,
);

export const selectDevtoolsUserError = createSelector([selectDevtoolsUserState], state => state?.error);

export const selectDevtoolsUserProfileId = createSelector([selectDevtoolsUserState], state => state?.data?.identifier);

export const selectDevtoolsUserGroups = createSelector([selectDevtoolsUserState], user => user?.data?.groups);
